<template>
  <div class="chat_window">
    <div class="top_menu">
      <div class="buttons">
        <div class="button close"></div>
        <div class="button minimize"></div>
        <div class="button maximize"></div>
      </div>
      <div class="title">Mirror-Chat<span style="font-size: small;">&nbsp;&nbsp;v1.2.3</span></div>
    </div>
    <ul class="messages" id="msg_container"></ul>
    <div class="bottom_wrapper clearfix">
      <div class="message_input_wrapper">
        <input class="message_input" placeholder="请输入您的问题..." />
      </div>
      <div class="send_message">
        <div class="icon"></div>
        <div class="text">发送</div>
      </div>
      <div class="buttom_infomation">
        <b>Powered by ChatGPT3.5, check <a href="#" @click="toDonate">here</a> to know more about Mirror-Chat.</b>
      </div>
    </div>
  </div>
  <el-drawer v-model="donate" title="Welcome to Mirror-Chat" direction="rtl" :size="drawerPercent">
    <el-text class="mx-1 donate_des" size="large" style="text-align: left;"></el-text>
    <el-image style="width: 200px; height: 200px" :src="authorUrl" fit="fill" /><br />
  </el-drawer>
  <div class="message_template">
    <li class="message">
      <div class="avatar"></div>
      <div class="text_wrapper">
        <div class="text"></div>
      </div>
    </li>
  </div>
  <div class="message_loading" v-loading="loading" element-loading-text="思考中..." :element-loading-spinner="svg"
    element-loading-background="rgba(122, 122, 122, 0.3)" element-loading-svg-view-box="-10, -10, 50, 50">
  </div>
</template>

<style scoped>
@import './../css/chat.css';
@import './../css/private.css';
</style>

<script>
import { ref } from 'vue';
export default {
  setup() {
    let donate = ref(false);
    let loading = ref(true);
    const drawerPercent = "50%";
    const authorUrl = require("@/assets/pay_qrcode.png");
    const svg = `
        <path class="path" d="
          M 30 15
          L 28 17
          M 25.61 25.61
          A 15 15, 0, 0, 1, 15 30
          A 15 15, 0, 1, 1, 27.99 7.5
          L 15 15
        " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
      `;

    function toDonate() {
      var width = document.body.clientWidth;
      this.donate = true;
      if (width < 600) {
        this.drawerPercent = '90%'
        return;
      }
      this.drawerPercent = '50%'
    }

    return {
      donate,
      authorUrl,
      loading,
      svg,
      drawerPercent,
      toDonate,
    }
  },

  methods() {

  },
}

</script>

<style scoped>
.demo-image .block {
  padding: 30px 0;
  text-align: center;
  border-right: solid 1px var(--el-border-color);
  display: inline-block;
  width: 20%;
  box-sizing: border-box;
  vertical-align: top;
}

.demo-image .block:last-child {
  border-right: none;
}

.demo-image .demonstration {
  display: block;
  color: var(--el-text-color-secondary);
  font-size: 14px;
  margin-bottom: 20px;
}
</style>
